import { useId, useState } from 'react'
import type { ReactNode } from 'react'
import { MdAdd, MdRemove } from 'react-icons/md'
import styled from 'styled-components'

import { theme } from '@/styles/theme'

import { Line } from '@/components/elements/Line'

type Props = {
  title: string
  children: ReactNode
}

export const SpAccordion = ({ title, children }: Props) => {
  const [isExpand, setIsExpand] = useState(false)
  const id = useId()

  return (
    <Wrapper>
      <Button
        onClick={() => setIsExpand((prev) => !prev)}
        aria-expanded={isExpand}
        aria-controls={id}
      >
        {title}
        {isExpand ? <CloseIcon /> : <OpenIcon />}
      </Button>
      <SpLine color="grey" weight={1} direction="horizon" />
      <Content id={id}>{children}</Content>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  @media screen and (max-width: 1047px) {
    width: 100%;
    background: ${theme.colors.backgroundGrey};
  }
`

const Button = styled.button`
  display: none;

  @media screen and (max-width: 1047px) {
    font-size: 16px;
    font-weight: bold;
    width: 100%;
    padding: 15px 12px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: ${theme.colors.textTitle};
    background: ${theme.colors.backgroundGrey};
    border: none;
    border-radius: 8px;

    &[aria-expanded='true'] {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }

    &[aria-expanded='false'] ~ div {
      height: 0;
      padding-top: 0;
      padding-bottom: 0;
      opacity: 0;
      overflow: hidden;
      pointer-events: none;
    }
  }
`

const SpLine = styled(Line)`
  display: none;

  @media screen and (max-width: 1047px) {
    display: block;
    margin: 0 12px;
  }
`

const Content = styled.div`
  height: 100%;

  @media screen and (max-width: 1047px) {
    transition: 0.3s;
    height: auto;
    padding: 16px 12px;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
  }
`

const OpenIcon = styled(MdAdd)`
  font-size: 30px;
  color: ${theme.colors.grey};
`

const CloseIcon = styled(MdRemove)`
  font-size: 30px;
  color: ${theme.colors.grey};
`
